import { useMount } from 'ahooks';
import * as echarts from 'echarts/core';
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Context = /*#__PURE__*/createContext(null);
export const useChartGroupContext = () => useContext(Context);
const ChartGroup = _ref => {
  let {
    id,
    children
  } = _ref;
  useMount(() => {
    echarts.connect(id);
  });
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: {
      id
    },
    children: children
  });
};
export default ChartGroup;